import { render, staticRenderFns } from "./AppBreadCrumb.vue?vue&type=template&id=55cca123&scoped=true"
import script from "./AppBreadCrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadCrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cca123",
  null
  
)

export default component.exports